// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPaymentAddressResponseDto } from './IPaymentAddressResponseDto';
import {
    IPaymentAddressResponseDtoFromJSON,
    IPaymentAddressResponseDtoFromJSONTyped,
    IPaymentAddressResponseDtoToJSON,
    IPaymentAddressResponseDtoToJSONTyped,
} from './IPaymentAddressResponseDto';

/**
 * 
 * @export
 * @interface IChecksResponseAggregatorDto
 */
export interface IChecksResponseAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDto
     */
    check_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    employee_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    employer_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof IChecksResponseAggregatorDto
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {Date}
     * @memberof IChecksResponseAggregatorDto
     */
    issued_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IChecksResponseAggregatorDto
     */
    status_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    current_status?: IChecksResponseAggregatorDtoCurrentStatusEnum;
    /**
     * 
     * @type {IPaymentAddressResponseDto}
     * @memberof IChecksResponseAggregatorDto
     */
    check_address?: IPaymentAddressResponseDto;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    pay_to?: string;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    void_reason?: string;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDto
     */
    payment_method_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDto
     */
    reissue_check_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    reissue_payment_method_type?: IChecksResponseAggregatorDtoReissuePaymentMethodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDto
     */
    lockbox_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    lockbox_type?: IChecksResponseAggregatorDtoLockboxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IChecksResponseAggregatorDto
     */
    check_type?: IChecksResponseAggregatorDtoCheckTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IChecksResponseAggregatorDtoCurrentStatusEnum {
    PENDING = 'PENDING',
    ISSUED = 'ISSUED',
    CLEARED = 'CLEARED',
    VOIDED = 'VOIDED',
    EXPIRED = 'EXPIRED',
    EXPIRING = 'EXPIRING',
    REISSUING = 'REISSUING',
    VOIDING = 'VOIDING',
    REISSUE_REQUIRED = 'REISSUE_REQUIRED',
    RETURNED = 'RETURNED'
}
/**
* @export
* @enum {string}
*/
export enum IChecksResponseAggregatorDtoReissuePaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IChecksResponseAggregatorDtoLockboxTypeEnum {
    UNKNOWN = 'UNKNOWN',
    INBOUND_TOA = 'INBOUND_TOA',
    OUTBOUND_TOA = 'OUTBOUND_TOA',
    RETURNED_CHECK = 'RETURNED_CHECK',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    BENEFICIARY = 'BENEFICIARY',
    HSA_FORM = 'HSA_FORM',
    MISTAKEN_DISTRIBUTION = 'MISTAKEN_DISTRIBUTION',
    HSA_ROLLOVER_FORM = 'HSA_ROLLOVER_FORM',
    HSA_CONTRIBUTION_FORM = 'HSA_CONTRIBUTION_FORM',
    HSA_TRANSFER_DIVORCE = 'HSA_TRANSFER_DIVORCE',
    HSA_ACCOUNT_CLOSURE = 'HSA_ACCOUNT_CLOSURE',
    COMBINE_HSA = 'COMBINE_HSA',
    DEATH_DISTRIBUTION = 'DEATH_DISTRIBUTION',
    POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
    RETURNED_MAIL = 'RETURNED_MAIL',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION'
}
/**
* @export
* @enum {string}
*/
export enum IChecksResponseAggregatorDtoCheckTypeEnum {
    CLAIM = 'CLAIM',
    LOCKBOX = 'LOCKBOX'
}


/**
 * Check if a given object implements the IChecksResponseAggregatorDto interface.
 */
export function instanceOfIChecksResponseAggregatorDto(value: object): value is IChecksResponseAggregatorDto {
    return true;
}

export function IChecksResponseAggregatorDtoFromJSON(json: any): IChecksResponseAggregatorDto {
    return IChecksResponseAggregatorDtoFromJSONTyped(json, false);
}

export function IChecksResponseAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IChecksResponseAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'check_id': json['check_id'] == null ? undefined : json['check_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'claim_ids': json['claim_ids'] == null ? undefined : json['claim_ids'],
        'issued_date': json['issued_date'] == null ? undefined : (new Date(json['issued_date'])),
        'status_date': json['status_date'] == null ? undefined : (new Date(json['status_date'])),
        'current_status': json['current_status'] == null ? undefined : json['current_status'],
        'check_address': json['check_address'] == null ? undefined : IPaymentAddressResponseDtoFromJSON(json['check_address']),
        'pay_to': json['pay_to'] == null ? undefined : json['pay_to'],
        'void_reason': json['void_reason'] == null ? undefined : json['void_reason'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'reissue_check_id': json['reissue_check_id'] == null ? undefined : json['reissue_check_id'],
        'reissue_payment_method_type': json['reissue_payment_method_type'] == null ? undefined : json['reissue_payment_method_type'],
        'lockbox_id': json['lockbox_id'] == null ? undefined : json['lockbox_id'],
        'lockbox_type': json['lockbox_type'] == null ? undefined : json['lockbox_type'],
        'check_type': json['check_type'] == null ? undefined : json['check_type'],
    };
}

export function IChecksResponseAggregatorDtoToJSON(json: any): IChecksResponseAggregatorDto {
    return IChecksResponseAggregatorDtoToJSONTyped(json, false);
}

export function IChecksResponseAggregatorDtoToJSONTyped(value?: IChecksResponseAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'check_id': value['check_id'],
        'amount': value['amount'],
        'employee_name': value['employee_name'],
        'employer_name': value['employer_name'],
        'employee_id': value['employee_id'],
        'claim_ids': value['claim_ids'],
        'issued_date': value['issued_date'] == null ? undefined : ((value['issued_date']).toISOString()),
        'status_date': value['status_date'] == null ? undefined : ((value['status_date']).toISOString()),
        'current_status': value['current_status'],
        'check_address': IPaymentAddressResponseDtoToJSON(value['check_address']),
        'pay_to': value['pay_to'],
        'void_reason': value['void_reason'],
        'payment_method_id': value['payment_method_id'],
        'reissue_check_id': value['reissue_check_id'],
        'reissue_payment_method_type': value['reissue_payment_method_type'],
        'lockbox_id': value['lockbox_id'],
        'lockbox_type': value['lockbox_type'],
        'check_type': value['check_type'],
    };
}

